<template>
	<div>
		<div v-if="loading">Please wait ...</div>
		<div id="rp_container" style="width: 500px;height:500px;"></div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		data: () => ({
			loading: false
		}),
		methods: {
			createScript() {
				if (!this.scriptCreated) {
					let element = document.createElement('script')
				    element.setAttribute('src', 'https://checkout.reepay.com/checkout.js');
				    element.addEventListener('load', () => {
				    	this.finishCreatePaymentWindow();	
				    });
				    document.head.appendChild(element);
				}
			},
			finishCreatePaymentWindow() {
				Vue.api.post('/user/credit-card/parameters/add-card', {}, {
					before: () => this.loading = true,
					always: () => this.loading = false,
					callback: data => this.createReepayCheckout(data)
				});
			},
			createReepayCheckout(data) {
				new Reepay.EmbeddedCheckout(data.response.id, {
					html_element: 'rp_container'
				}).addEventHandler(0, () => {
					this.$emit('created');
				});
			}
		},
		created() {
			this.createScript();
		}
	}
</script>